export const spartans = [
    {id:1,   name:"Hoplite", wood:110, clay:185, iron:110, crop:35},
    {id:2,   name:"Sentinel", wood:185, clay:150, iron:35, crop:75},
    {id:3,   name:"Shieldsman", wood:145, clay:95, iron:245, crop:45},
    {id:4,   name:"Twinsteel Therion", wood:130, clay:200, iron:400, crop:65},
    {id:5,   name:"Elpida Rider", wood:555, clay:445, iron:330, crop:110},
    {id:6,   name:"Corinthian Crusher", wood:660, clay:495, iron:995, crop:165 	},
    {id:7,   name:"Ram", wood:525, clay:260, iron:790, crop:130},
    {id:8,   name:"Ballista", wood:550, clay:1240, iron:825, crop:135},
    {id:9,   name:"Ephor", wood:33450, clay:30665, iron:36240, crop:13935},
    {id:10,  name:"Settler", wood:5115, clay:5580, iron:6045, crop:3255}
    ]